import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type { State } from '../../state'

export const DOC = gql`
  mutation SubmitCheckInResponse(
    $tenantId: ID!
    $zoneId: ID!
    $prompt: String
    $response: String!
    $mood: String
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        submitCheckInResponse(prompt: $prompt, response: $response, mood: $mood)
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.SubmitCheckInResponseMutation,
  Required<Pick<State, 'responseToTheResponse'>> | undefined,
  graphql.schema.SubmitCheckInResponseMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.nest(
    'responseToTheResponse',
    graphql.transformers.OUT.select(
      'tenant',
      graphql.transformers.OUT.select(
        'zone',
        graphql.transformers.OUT.select('submitCheckInResponse', PASS_THROUGH),
      ),
    ),
    { onNullish: 'remove' },
  ),
})
